module.exports = __webpack_public_path__ + "img/server.6e2e1eb8.webp";